export default (props, vars) =>
  props?.['applicationStatus'].getDescriptionComponent(
    vars?.['defaultbox145']?.['item']
  );
